import { render, staticRenderFns } from "./invoiceNav.vue?vue&type=template&id=cd4e37b2&scoped=true&"
var script = {}
import style0 from "./invoiceNav.vue?vue&type=style&index=0&id=cd4e37b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4e37b2",
  null
  
)

export default component.exports